<template>
  <hm-content title="核销中心">
    <div>
      <el-input
        clearable
        v-model.trim="authCode"
        placeholder="输入验证码"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="writeOff">核销</el-button>
    </div>
    <div class="title">核销记录</div>
    <el-table stripe border :data="chargeList" style="width: 100%" size="small">
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="updateTime"
        label="核销时间"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="updateName"
        label="核销操作人"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="authCode"
        label="核销码"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="actName"
        label="所属活动"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="actSite"
        label="所属地点"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="actRound"
        label="所属场次"
      ></el-table-column>
    </el-table>
  </hm-content>
</template>

<script>
 
 import { getLoginUser } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
    
  data() {
    return {
      authCode: ""
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  computed: mapGetters(["chargeList"]),
  methods: {
    queryList() {
      this.$store.dispatch("queryChargeList");
    },
    writeOff() {
      this.$store
        .dispatch("chargeOffFromCode", {
          authCode: this.authCode,
          userId: getLoginUser().userId,
          name: getLoginUser().name
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  margin: 20px 0;
  font-size: 14px;
  &::before {
    content: "";
    width: 3px;
    height: 12px;
    background: #e60065;
    display: inline-block;
    margin-right: 10px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
